import { Instance } from 'mobx-state-tree';
import { ProjectStopsSchedulingFailedDtoModelBase } from './ProjectStopsSchedulingFailedDtoModel.base';

/* The TypeScript type of an instance of ProjectStopsSchedulingFailedDtoModel */
export interface ProjectStopsSchedulingFailedDtoModelType extends Instance<typeof ProjectStopsSchedulingFailedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopsSchedulingFailedDtoModel */
export { selectFromProjectStopsSchedulingFailedDto, projectStopsSchedulingFailedDtoModelPrimitives, ProjectStopsSchedulingFailedDtoModelSelector } from './ProjectStopsSchedulingFailedDtoModel.base';

/**
 * ProjectStopsSchedulingFailedDtoModel
 *
 * Scheduling stops failed
 */
export const ProjectStopsSchedulingFailedDtoModel = ProjectStopsSchedulingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
